module.exports = __webpack_public_path__ + "img/portrait-id-before.d8f82a1c.jpg";